import React, { useMemo } from "react";
import {
  formatSummaryValue,
  parseInsightSummary,
} from "./utils";

interface SummaryDisplayProps {
  summary: string;
}

const SummaryDisplay: React.FC<SummaryDisplayProps> = ({ summary }) => {
  const parsedSummary = useMemo(
    () => parseInsightSummary(summary),
    [summary]
  );

  if (!parsedSummary) return null;

  const { formatted, parsed, isFlatObject } = parsedSummary;

  if (isFlatObject && parsed && typeof parsed === "object") {
    const entries = Object.entries(parsed as Record<string, unknown>);
    return (
      <table className="w-full border border-gray-300 text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-2 py-1 text-left font-medium">Field</th>
            <th className="border px-2 py-1 text-left font-medium">Value</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([key, value]) => (
            <tr key={key} className="border-b">
              <td className="border px-2 py-1 align-top font-medium text-neutral-700 whitespace-nowrap">
                {key}
              </td>
              <td className="border px-2 py-1 align-top break-all font-mono text-neutral-900">
                {formatSummaryValue(value)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <pre className="bg-white p-3 rounded border text-sm max-h-[240px] overflow-auto font-mono text-neutral-900 leading-relaxed">
      {formatted}
    </pre>
  );
};

export default SummaryDisplay;
